module.exports = __webpack_public_path__ + "static/img/stu-logo.0df5380d.png";